import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBooleanGroupSubstract2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBooleanGroupSubstract2"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2H8V6H10V4H12V2ZM17 2H13V4H17V2ZM22 2H18V4H20V6H22V2ZM22 11V7H20V11H22ZM16 16V14H10V8H8H2V22H16V16ZM18 14V16H22V12H20V14H18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBooleanGroupSubstract2;
